import React, {useState} from "react";
import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import marketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import MarketRepository from "../../../Main/repository/MarketRepository";
import {useTranslation} from "react-i18next";

export default function ServiceMode() {
    const {t} = useTranslation();
    const [state, setState] = useState<MarketSettingLocalStorage['service']>("netbee");
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;

    const values = [
        {value: "hami", label: t("setting.hami")},
        {value: "netbee", label: t("setting.netbee")},
        {value: "localServer", label: t("setting.localServer")},
    ];

    const handleSubmit = (e: React.FormEvent) => {
        if (state !== "netbee") MarketRepository.setSettingMarket("showQrCode", false);
        AppSettingController.setService(state, e);
        if (state === "hami" || state === "localServer") {
            setTimeout(() => window.scrollBy({top: 250, behavior: "smooth"}), 100);
        }
    };

    return (
        <section>
            <p>{t("setting.service")}</p>
            <div className="form-receipt">
                <form onSubmit={handleSubmit}>
                    <select
                        onChange={e => setState(e.target.value as MarketSettingLocalStorage['service'])}
                        defaultValue={setting.service}
                    >
                        {values.map((value) => (
                            <option value={value.value} key={value.value}>
                                {value.label}
                            </option>
                        ))}
                    </select>
                    <button type="submit">{t("submit")}</button>
                </form>
            </div>
        </section>
    );
}